import React, { useState, useEffect } from 'react';

//src image
import banner from '../img/banner.png';
import logo from '../img/mulogo.png';

//css
import '../css/index.css';

//local store
import { useDispatch } from 'react-redux'
import { connect } from "react-redux";

//Useraction

import { useNavigate } from 'react-router-dom';
import { RiLogoutBoxLine, RiCheckboxCircleFill, RiCloseCircleFill } from "react-icons/ri";
import { matchRoutes, useLocation } from "react-router-dom"
import Header from './header/Header';
import NavBtn from '../Nav/NavBtn';
import { Image } from '../img';
import { Utility } from '../Utility/Utility';
import TakingAttendance from './TakingAttendance';

// import { RiLogoutBoxLine } from "react-icons/ri";

const Dashboard = (props) => {
    const currentLocation = useLocation();

    const dispatch = useDispatch();

    const navigate = useNavigate();
    const matches = matchRoutes(Utility.routes, currentLocation);
    console.log('matches', matches)
    const rightIconAry = [
        {
            icon: 'How_dark',
            label: 'How to access OLE',
            path: '/how_to_access_ole',
        },
        {
            icon: 'Dashboard_light',
            label: 'Dashboard',
            path: '/ashboard'
        },
        {
            icon: 'Course_light',
            label: 'Course Page',
            path: '/course_page',
        },
        {
            icon: 'Attendance_light',
            label: 'Taking Attendance',
            path: '/taking_attendance'
        },
        {
            icon: 'Assignment_light',
            label: 'Assignment',
            path: '/assignment',
        },
        {
            icon: 'Zoom_light',
            label: 'Zoom Recording',
            path: '/zoom_recording',
        },
        {
            icon: 'Teaching_light',
            label: 'Teaching Tools',
            path: '/teaching_tools',
        }
    ]
    useEffect(() => {
        const script = document.createElement('script');

        script.text = ` 
            try{
                window["showVideoProgress"] = false;
                window["applyVideoCue"] = false;
                
            }catch(e){
                console.log(e);
            }
        
        `;
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }
    }, []);

    return (
        <>
            <div className='MainContainer'>
                <Header />
                <div className={'MainContent'}>
                    <img className='MainContentFixBottomImageOnly' src={Image.inner_pages_bg1} alt='banner' />
                    <div className='MainContentFixBottomLine'></div>
                    <div className={'MainContentBox'}>
                        <img className="MainContentTopImage" src={Image.Sub_dashboard} alt='banner' />
                        <div className="MainContentTopContain">
                            <span className="MainContentTopText">Dashboard</span>
                        </div>
                        <div className={"MainContentMiddleDetail"} >
                            <div style={{ verticalAlign: 'middle' }}>
                                <p >
                                    <span>Please watch the following introduction video on the OLE Dashboard.
                                    </span>
                                </p>
                                <p >
                                    <span>
                                    </span>
                                </p>
                                <div className='dashBoardIframeContain'>
                                    <iframe src="./dashBoardVideo.html" allowfullscreen="true" title="W3Schools Free Online Web Tutorials" ></iframe>
                                </div>
                            </div>
                        </div>
                        <NavBtn prevItem='/how-to-access-ole' nextItem='/course-page'/>
                    </div>
                </div>
            </div>
        </>
    )
};


const mapStateToProps = (state) => {
    const { userInfo } = state;
    return {
        userInfo
    }
}


// export default Dashboard;
export default connect(mapStateToProps)(Dashboard);